import TrocaCreditoService from "@/services/TrocaCreditoService";

export const trocaCredito = {
  namespaced: true,
  state: {},
  actions: {
    getTrocaCreditoBuscarVenda(_, payload) {
      return TrocaCreditoService.BuscarVenda(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response.data)
      );
    },
    getTrocaCreditoDisponiveis(_, payload) {
      return TrocaCreditoService.Disponiveis(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response.data)
      );
    },
    getTrocaCreditoListar(_, payload) {
      return TrocaCreditoService.Listar(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response.data)
      );
    },
    postTrocaCreditoGerar(_, payload) {
      return TrocaCreditoService.Gerar(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response.data)
      );
    },
    getTrocaCreditoImprimir(_, payload) {
      return TrocaCreditoService.Imprimir(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response?.data || error)
      );
    },
  },
  mutations: {},
};

export default trocaCredito;
